import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import Icon, {Icons} from '@pb/kit-component-icon';

type Props = {
    showUpdateGroup: boolean,
    openAssignToGroup: () => void,
    openDischargeFromGroup: () => void,

    showUpdateDeviceRegistration: boolean,
    openEnableDeviceRegistration: () => void,
    openDisableDeviceRegistration: () => void,

    showUpdateMfaSettings: boolean,
    openEnableMfaSettings: () => void,
    openDisableMfaSettings: () => void,

    showUpdateUserState: boolean,
    openUpdateUserStateTool: () => void,

    showUpdateUserNewsletter: boolean,
    openUpdateUserNewsletterTool: () => void,

    showUpdateUserAccount: boolean,
    openUpdateUserAccountTool: () => void,

    showSendWelcomeEmail: boolean,
    openSendWelcomeEmailTool: () => void,

    showUpdateLcdAnalysis: boolean,
    openSubscribeToLcdAnalysisTool: () => void,
    openUnsubscribeFromLcdAnalysisTool: () => void,

    showUpdateUserEntitlements: boolean,
    openUsersEntitlementsAssignTool: () => void,
    openUsersEntitlementsDischargeTool: () => void,
    showAssignProductSeat: boolean,
    openAssignProductSeat: () => void,
    showUnassignProductSeat: boolean,
    openUnassignProductSeat: () => void,
};

export const UsersGroupsToolsMenu = (props: Props) => (
    <DropdownMenu
        anchor={({positionRef, getAnchorProps, anchorRef}) => (
            <FlatButton
                endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                {...getAnchorProps()}
                ref={anchorRef}>
                <b>Bulk Actions</b>
            </FlatButton>
        )}>
        {props.showUpdateGroup ? (
            <DropdownMenuItem caption="Set Account Group" iconAfter={Icons.ANGLE_RIGHT}>
                <DropdownMenuItem
                    caption="Assign To Group"
                    onClick={props.openAssignToGroup}
                />
                <DropdownMenuItem
                    caption="Unassign From Group"
                    onClick={props.openDischargeFromGroup}
                />
            </DropdownMenuItem>
        ) : null}
        {props.showUpdateDeviceRegistration ? (
            <DropdownMenuItem caption="Device Registration" iconAfter={Icons.ANGLE_RIGHT}>
                <DropdownMenuItem
                    caption="Enable Device Registration"
                    onClick={props.openEnableDeviceRegistration}
                />
                <DropdownMenuItem
                    caption="Disable Device Registration"
                    onClick={props.openDisableDeviceRegistration}
                />
            </DropdownMenuItem>
        ) : null}
        {props.showUpdateMfaSettings ? (
            <DropdownMenuItem caption="MFA Settings" iconAfter={Icons.ANGLE_RIGHT}>
                <DropdownMenuItem
                    caption="Enable Multi-Factor Authentication"
                    onClick={props.openEnableMfaSettings}
                />
                <DropdownMenuItem
                    caption="Disable Multi-Factor Authentication"
                    onClick={props.openDisableMfaSettings}
                />
            </DropdownMenuItem>
        ) : null}
        {props.showUpdateLcdAnalysis ? (
            <DropdownMenuItem caption="LCD Credit Analysis" iconAfter={Icons.ANGLE_RIGHT}>
                <DropdownMenuItem
                    caption="Subscribe"
                    onClick={props.openSubscribeToLcdAnalysisTool}
                />
                <DropdownMenuItem
                    caption="Unsubscribe"
                    onClick={props.openUnsubscribeFromLcdAnalysisTool}
                />
            </DropdownMenuItem>
        ) : null}
        {props.showUpdateUserEntitlements ? (
            <DropdownMenuItem caption="Update Users Entitlements" iconAfter={Icons.ANGLE_RIGHT}>
                <DropdownMenuItem
                    caption="Assign"
                    onClick={props.openUsersEntitlementsAssignTool}
                />
                <DropdownMenuItem
                    caption="Unassign"
                    onClick={props.openUsersEntitlementsDischargeTool}
                />
            </DropdownMenuItem>
        ) : null}
        {props.showAssignProductSeat ? (
            <DropdownMenuItem caption="Product Seat" iconAfter={Icons.ANGLE_RIGHT}>
                <DropdownMenuItem caption="Assign" onClick={props.openAssignProductSeat}/>
                <DropdownMenuItem caption="Unassign" onClick={props.openUnassignProductSeat}/>
            </DropdownMenuItem>
        ) : null}
        {props.showUpdateUserState ? (
            <DropdownMenuItem
                caption="Set User State"
                onClick={props.openUpdateUserStateTool}
            />
        ) : null}
        {props.showUpdateUserNewsletter ? (
            <DropdownMenuItem
                caption="Set Newsletter Subscriptions"
                onClick={props.openUpdateUserNewsletterTool}
            />
        ) : null}
        {props.showUpdateUserAccount ? (
            <DropdownMenuItem
                caption="Change User's Account"
                onClick={props.openUpdateUserAccountTool}
            />
        ) : null}
        {props.showSendWelcomeEmail ? (
            <DropdownMenuItem
                caption="Send Welcome Email"
                onClick={props.openSendWelcomeEmailTool}
            />
        ) : null}
    </DropdownMenu>
);
